export default "__VITE_ASSET__BGliusnC__"